(function($, root, undefined) {
  $(function() {
    $('.poster-video-img').click(function(){      
      var posterVideoUrl = $(this).parent().data('url');
      if(posterVideoUrl != '' && posterVideoUrl){
        $(this).parent().html('<video id="join-hero-video" muted loop controls autoplay><source src="'+ posterVideoUrl +'" type="video/mp4"></video>');
      }
    });
    $(".com-media-list").slick({
      speed: 1000,
      autoplay: false,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '',
      nextArrow: '<span class="right-arrow"><svg width="18" height="34" viewBox="0 0 18 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 33L16 17L1 0.999998" stroke="black" stroke-width="2"/></svg></span>',
    });

    $('.com-main-media .f-media-poster .control-option').click(function(){
      $(this).parents('.f-media-poster').addClass('d-none');
      $(this).parents('.com-main-media').find('.featured-media').removeClass('d-none');

      var featuredVideo = $(this).parents('.com-main-media').find('video');
      featuredVideo.trigger('play');
    });

    $('.com-media-list .single-media .control-option').click(function(){
      var mediaInfoDom = $(this).parent().next();
      var mediaVideoUrl = mediaInfoDom.find('.media-url').text();
      var mediaTitle = mediaInfoDom.find('.media-title').text();
      var mediaContent = mediaInfoDom.find('.media-content').text();
      $('.com-main-media .featured-media').removeClass('d-none');
      $('.com-main-media  .f-media-poster').addClass('d-none');

      updateFmediaContent(mediaVideoUrl, mediaTitle, mediaContent);
    });

    $('.com-media-list').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.com-main-media .featured-media').addClass('d-none');
      $('.com-main-media  .f-media-poster').removeClass('d-none');
    });
    
    $('.com-media-list').on('afterChange', function(event, slick, currentSlide){
      var mediaPoster = $('.com-media-list .single-media.slick-current .media-poster img.media-poster-img').attr('src');
      var mediaVideoUrl = $('.com-media-list .single-media.slick-current .media-info .media-url').text();
      var mediaTitle = $('.com-media-list .single-media.slick-current .media-info .media-title').text();
      var mediaContent = $('.com-media-list .single-media.slick-current .media-info .media-content').text();
      updateFmediaContent(mediaVideoUrl, mediaTitle, mediaContent, mediaPoster);
    });

    function updateFmediaContent(videoUrl, title, content, poster){
      var videoHtml = '<video class="w-100" controls autoplay><source src="'+ videoUrl +'" type="video/mp4"></video>';
      if(poster){
        var videoHtml = '<video class="w-100" controls><source src="'+ videoUrl +'" type="video/mp4"></video>';
      }
      $('.com-main-media .featured-media').html(videoHtml);
      $('.com-media-content h3.active-mtitle').text(title);
      $('.com-media-content .active-mcontent').text(content);

      if(poster){
        $('.com-main-media .f-media-poster img.poster-imge').attr('src', poster);
      }
    }

    // FAQ list
    $('.faq-list .single-faq .heading').click(function(){
      $(this).toggleClass('active');
      $(this).parent().find('.f-icon').toggleClass('arrow-animate');
      $(this).parent().find('.faq-answer').slideToggle(280);
    });
  });
})(jQuery, this);